import { useState } from 'react'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'

import Button from '@/components/Button'
import FieldNumeric from '@/components/FieldNumeric'
import Modal from '@/components/Modal'
import NumericKeyboard from '@/components/NumericKeyboard'
import useLayout from '@/layout/useLayout'

const LockedTicketModal = ({ onClose, onSuccess }: { onClose: () => void; onSuccess: () => void }) => {
  const { t } = useTranslation()
  const [code, setCode] = useState('')
  const { appData } = useLayout()
  const { restrictedTicketsCode } = appData || {}

  const handleUnlock = () => {
    console.log(code, restrictedTicketsCode)
    if (code === restrictedTicketsCode) {
      toast.success(t('ticketUnlocked'))
      onSuccess()
    } else {
      toast.error(t('ticketUnlockError'))
    }
  }

  const handleCancel = () => {
    onClose()
  }

  return (
    <Modal onClose={onClose} variant="centered">
      <h3>{t('fillPinCode')}</h3>
      <FieldNumeric digits={4} defaultValue={code} onChange={value => setCode(value)} />
      <NumericKeyboard onChange={value => setCode(value)} value={code} maxLength={4} />
      <Button variant="secondary" onClick={handleCancel}>
        {t('cancel')}
      </Button>
      <Button variant="primary" onClick={handleUnlock} disabled={!code || code.length < 4}>
        {t('unlock')}
      </Button>
    </Modal>
  )
}

export default LockedTicketModal
